import { gql } from "@apollo/client";

/** 보스·core 등에서 사용. store-management 수정 폼용 필드 포함. */
export const GET_SELLER_STORE = gql`
  query getSellerStoreData {
    getSellerStore {
      id
      title
      address
      detailAddress
      navigationInfo
      contactNumber
      closingHours
      lng
      lat
      img
      reserveTime
      liveOrderNotice
      packId
      packDiscountRateTier
      isPackOrderLimitConfigEnabled
      signupState
      todaysProducts {
        id
        name
        price
        discountPrice
        userPrice
        quantity
        isDeleted
      }
      pack {
        id
        currentCount
        isTodayEnabled
        isTomorrowEnabled
        isOverTodayPickupTime
        price
        discountPrice
        discountRate
        userPrice
        quantity
        cancelMessage
      }
    }
  }
`;

export const UPDATE_STORE = gql`
  mutation UpdateStore(
    $id: Int!
    $title: String
    $lat: Float
    $lng: Float
    $address: String
    $detailAddress: String
    $navigationInfo: String
    $contactNumber: String
    $closingHours: String
    $img: Upload
  ) {
    updateStore(
      id: $id
      title: $title
      lat: $lat
      lng: $lng
      address: $address
      detailAddress: $detailAddress
      navigationInfo: $navigationInfo
      contactNumber: $contactNumber
      closingHours: $closingHours
      img: $img
    ) {
      id
      title
      address
      contactNumber
      closingHours
    }
  }
`;

export const CREATE_STORE = gql`
  mutation CreateStore(
    $lat: Float
    $lng: Float
    $title: String!
    $address: String
    $detailAddress: String
    $navigationInfo: String
    $contactNumber: String
    $closingHours: String
    $img: Upload
  ) {
    createStore(
      lat: $lat
      lng: $lng
      title: $title
      address: $address
      detailAddress: $detailAddress
      navigationInfo: $navigationInfo
      contactNumber: $contactNumber
      closingHours: $closingHours
      img: $img
    ) {
      id
      title
      address
      contactNumber
      closingHours
    }
  }
`;

export const GET_COORDS = gql`
  query GetCoords($address: String!) {
    getCoords(address: $address) {
      lat
      lng
    }
  }
`;

export const UPDATE_STORE_CLOSING_HOURS = gql`
  mutation UpdateStoreClosingHours($closingHours: String!) {
    updateStoreClosingHours(closingHours: $closingHours) {
      id
      closingHours
    }
  }
`;
